'use client';
import Script from 'next/script';

function ClickSpark() {
  return (
    <>
      <click-spark></click-spark>
      <Script id={'sparkle'} type="text/javascript" src={'/js/sparkle.js'}></Script>
    </>
  );
}

export default ClickSpark;
